export default {
	getBlePrinterParameterByModelName: state => {
		return (modelName, parameter) => state.blePrinterParameters[modelName][parameter];
	},
	getMenuConf: (state) => ({
		...state.menu,
		items: state.menu.breadcrumbItems || state.menu.items
	})
};
